let locationSelector

function vueLocationSelector() {
    locationSelector = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const storeSelector = window.storeSelector()

            if (localStorage.getItem('currentUserLocation')) storeSelector.updateLocation(JSON.parse(localStorage.getItem('currentUserLocation')));
            if (localStorage.getItem('currentNearestStore')) storeSelector.updateNearestStore(JSON.parse(localStorage.getItem('currentNearestStore')));
            else storeSelector.geolocation();

            const locationSearch = Vue.ref('');
            const searchOpen = Vue.ref(false);
            const subset = Vue.ref(false);

            const locationShow = Vue.computed(() => (storeSelector.nearestStore && !searchOpen.value));
            const showSuburbList = Vue.computed(() => (searchOpen.value && subset.value));
            const locationString = Vue.computed(() => storeSelector?.location?.name
                ? storeSelector.location.name.split(',')[0]
                : false);


            const headerInputListener = (liveInput, suburbOutput, suburbs) => {
                if (liveInput.length > 2) {
                    const fuseOptions = {
                        includeScore: true,
                        keys: ['name'],
                        threshold: 0.4,
                        shouldSort: true
                    }
                    const fuse = new Fuse(suburbs, fuseOptions);
                    const result = fuse.search(`${liveInput}`);
                    suburbOutput.value = result.slice(0, 5);
                }
            }

            const showSearchBox = async () => {
                try {
                    const response = await fetch(sub);
                    const suburbs = await response.json();
                    searchOpen.value = true;
                    Vue.watch(locationSearch, (newInput, oldInput) => {
                        if (newInput.length < oldInput.length) subset.value = false;
                        headerInputListener(newInput, subset, suburbs);
                    })
                } catch (e) {
                    console.error(e);
                }
            }

            const headerLocationSelect = (loc) => {
                storeSelector.locationSelect(`${loc.item.name}, ${loc.item.state}`, loc.item.latitude, loc.item.longitude)
                subset.value = false;
                searchOpen.value = false;
            }

            const closeSearch = () => searchOpen.value = false;

            return {
                searchOpen,
                showSearchBox,
                locationSearch,
                locationShow,
                subset,
                headerLocationSelect,
                storeSelector,
                showSuburbList,
                locationString,
                closeSearch
            };
        }
    })
    locationSelector.use(window.VueAppGlobals.pinia);
    locationSelector.mount('#store-selector');
}

if (window.Vue && window.Pinia) {
    vueLocationSelector();
} else {
    window.addEventListener('vue-ready', vueLocationSelector);
}
